import React from 'react';

import {observer} from "mobx-react";
import styles from "../styles/entity-scores-widget.module.scss";
import classNames from "classnames";
import {EntityLogo} from "../../../core/components/logos/entity-logo";
import {Ellipsis} from "../../../core/components/misc/ellipsis/ellipsis";
export const EntityScoresWidgetDropdownItem = observer(({controller, item, onChange}) => {
  const {state, terms} = controller;
  const {currentRoundFilter, isCompetitorPage} = state;
  const {WEB_FILTER_ACTIVE} = terms;

  const itemContainerProps = {
    className: classNames(styles.dropdown_item, {[styles.competition_item]: isCompetitorPage}),
    onClick: () => onChange && onChange(item)
  }
  const shouldRenderLabel: Boolean = !isCompetitorPage && item?.isCurrent && currentRoundFilter?.id !== item.id
  const shouldRenderCompetitionLogo: Boolean = isCompetitorPage && item?.id > 0
  const label: String = isCompetitorPage ? item?.shortName || item?.name : item?.title;

  const logoProps = {
    className: classNames(styles.dropdown_item_logo),
    entity: item,
    width: 24,
    height: 24
  }

  return <div {...itemContainerProps}>
    {
      shouldRenderCompetitionLogo ? <EntityLogo {...logoProps}/> : null
    }
    <Ellipsis text={label} className={classNames(styles.dropdown_item_label)}/>
    {
      shouldRenderLabel ? <div className={classNames(styles.dropdown_active_item)}>{WEB_FILTER_ACTIVE}</div> : null
    }
  </div>
});